import React from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { validOrganizationEmail } from '../../utilities/planEmailRequest';
import { normalizeContactDetails } from '../../utilities/contactDetails';
import { makeStyles } from './style';
import Icon from '../Icon';

export default function PlanEmailRequestFields({ contacts, to, onChoose, authorized, onAuthorize, disabled, previous, theme, section }: {
  contacts: any[]; to: string; onChoose: (email: string) => void; authorized: boolean;
  onAuthorize: (value: boolean) => void; disabled: boolean; previous: any; theme: any; section: 'recipient' | 'consent';
}) {
  const styles = makeStyles(theme);
  const choices = validOrganizationEmail(to) ? [] : contacts.map(normalizeContactDetails).filter((contact) => validOrganizationEmail(String(contact.email || ''))
    && (!to || `${contact.name || ''} ${contact.first_name || ''} ${contact.last_name || ''} ${contact.email}`.toLowerCase().includes(to.toLowerCase()))).slice(0, 6);
  if (section === 'recipient' && to && !choices.length) return null;
  return <View style={styles.wrap}>
    {section === 'recipient' && <>
    {!to && <Text style={styles.hint}>Choose a saved contact or enter the organization's email above.</Text>}
    {choices.map((contact) => <TouchableOpacity key={contact.id} accessibilityRole="button" disabled={disabled}
      accessibilityLabel={`Choose ${contact.name || contact.email}`} onPress={() => onChoose(contact.email)} style={styles.choice}>
      <Text style={styles.text}>{contact.name || [contact.first_name, contact.last_name].filter(Boolean).join(' ') || contact.email}</Text>
      <Text style={styles.hint}>{contact.email}</Text>
    </TouchableOpacity>)}
    </>}
    {section === 'consent' && <>
    {previous ? <Text accessibilityRole="alert" style={styles.hint}>
      {previous.email_update_request?.status === 'sent' ? 'Request sent. Check the plan inbox for a reply; confirmation of the change still needs to be checked.' : 'A request was already submitted. Delivery is not confirmed. Check the plan inbox before trying again.'}
    </Text> : <TouchableOpacity accessibilityRole="checkbox" accessibilityState={{ checked: authorized, disabled }}
      accessibilityLabel="I am authorized to request this email change" disabled={disabled} onPress={() => onAuthorize(!authorized)} style={[styles.consent, disabled && styles.disabled]}>
      <View style={[styles.checkbox, authorized && styles.checked]}>{authorized ? <Icon name="check" size={theme.icon.size.sm} color={theme.colors.primaryText} /> : null}</View>
      <Text style={styles.consentText}>I’m authorized to request this change and share future emails with people who have access to this plan.</Text>
    </TouchableOpacity>}
    <Text style={styles.hint}>The organization may ask for identity verification or a form. Existing inbox permissions still apply.</Text>
    </>}
  </View>;
}
